var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentHubPage',{attrs:{"data-qa":"themes","title":_vm.pageMeta.title,"description":_vm.pageMeta.description,"media-url":_vm.pageMetaOgImage,"items":_vm.themes,"total":_vm.total,"per-page":_vm.perPage,"card-url-name":"themes-all"}})
}
var staticRenderFns = []

export { render, staticRenderFns }